import styled from 'styled-components'

export const Avatar = styled.div`
  width: ${({ theme }) => theme.zds.size.variant210};
  height: ${({ theme }) => theme.zds.size.variant210};
  border-radius: 100%;
  background: linear-gradient(225deg, #061d38 14.64%, #1774de 85.36%);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    color: #fff;
  }
`
